import React from "react";

import HallRentals from "./HallRentals";
import Customers from "./CustomersTab";
import Analytics from "./Analytics";
import DeletedOrders from "./DeletedOrders";
import Expenses from "./Expenses";

const handleDragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "move";
};

const MainContent = ({
  activeTab,
  setIsSidebarOpen,
}) => {
  return (
    <main
      className="min-w-0 flex-1 max-h-screen overflow-x-auto overflow-y-hidden"
      onDragOver={(e) => handleDragOver(e)}
    >
      <div className="flex h-full min-h-0 flex-col p-4 sm:p-6 lg:p-8">
        {/* Mobile menu button */}
        <div className="mb-4 shrink-0 lg:hidden">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white shadow"
          >
            ☰ Menu
          </button>
        </div>

        {/* Page container */}
        <div className="flex-1 min-h-0"> 

          {activeTab === "hall-rentals" && <HallRentals />}

          {activeTab === "customers" && <Customers />}

          {activeTab === "analytics" && <Analytics />}

          {activeTab === "deleted-orders" && <DeletedOrders />}

          {activeTab === "expenses" && <Expenses />}

        </div>
      </div>
    </main>
  );
};

export default MainContent;